// src/AudioSpectrum/effects/circular.js
import { getRainbowColor } from '../colorUtils.js';

export const drawCircular = (ctx, frequencyData, width, height) => {
  const centerX = width / 2;
  const centerY = height / 2;
  const radius = Math.min(width, height) / 4;
  const maxRadius = Math.min(width, height) / 2 - 10;
  
  ctx.clearRect(0, 0, width, height);
  
  const barCount = Math.min(frequencyData.length / 2, 64);
  const angleStep = (Math.PI * 2) / barCount;
  
  for (let i = 0; i < barCount; i++) {
    const value = frequencyData[i];
    const angle = i * angleStep;
    const barLength = (value / 255) * (maxRadius - radius);
    
    const x1 = centerX + Math.cos(angle) * radius;
    const y1 = centerY + Math.sin(angle) * radius;
    const x2 = centerX + Math.cos(angle) * (radius + barLength);
    const y2 = centerY + Math.sin(angle) * (radius + barLength);
    
    ctx.strokeStyle = getRainbowColor(i, barCount);
    ctx.lineWidth = 4;
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.stroke();
  }
  
  // 중앙 원
  ctx.strokeStyle = '#4CAF50';
  ctx.lineWidth = 2;
  ctx.beginPath();
  ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
  ctx.stroke();
};